import { render } from "./DishList.vue?vue&type=template&id=bea4a94c"
import script from "./DishList.vue?vue&type=script&lang=js"
export * from "./DishList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__